import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActions = ({ 
  selectedItems, 
  onBulkAction, 
  onClearSelection,
  totalItems 
}) => {
  const [selectedAction, setSelectedAction] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const bulkActionOptions = [
    { value: '', label: 'اختر إجراء جماعي' },
    { value: 'activate', label: 'تفعيل المحدد' },
    { value: 'deactivate', label: 'إلغاء تفعيل المحدد' },
    { value: 'export', label: 'تصدير المحدد' },
    { value: 'delete', label: 'حذف المحدد' }
  ];

  const handleExecuteAction = async () => {
    if (!selectedAction || selectedItems?.length === 0) return;

    setIsProcessing(true);
    try {
      await onBulkAction(selectedAction, selectedItems);
      setSelectedAction('');
    } catch (error) {
      console.error('Bulk action failed:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleSelectAll = () => {
    onBulkAction('selectAll');
  };

  if (selectedItems?.length === 0) {
    return null;
  }

  return (
    <div className="bg-accent/10 border border-accent/20 rounded-lg p-4 animate-slide-up">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Selection Info */}
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} className="text-accent" />
            <span className="font-medium text-accent">
              تم تحديد {selectedItems?.length} عنصر
            </span>
          </div>

          <div className="flex items-center space-x-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={handleSelectAll}
              iconName="Square"
              iconPosition="left"
              iconSize={16}
              className="text-accent hover:text-accent"
            >
              تحديد الكل ({totalItems})
            </Button>

            <Button
              variant="ghost"
              size="sm"
              onClick={onClearSelection}
              iconName="X"
              iconPosition="left"
              iconSize={16}
              className="text-muted-foreground hover:text-foreground"
            >
              إلغاء التحديد
            </Button>
          </div>
        </div>

        {/* Bulk Actions */}
        <div className="flex items-center space-x-3">
          <Select
            options={bulkActionOptions}
            value={selectedAction}
            onChange={setSelectedAction}
            placeholder="اختر إجراء"
            className="min-w-48"
          />

          <Button
            variant="default"
            onClick={handleExecuteAction}
            disabled={!selectedAction || isProcessing}
            loading={isProcessing}
            iconName="Play"
            iconPosition="left"
            iconSize={16}
          >
            تنفيذ
          </Button>
        </div>
      </div>
      {/* Action Descriptions */}
      {selectedAction && (
        <div className="mt-3 pt-3 border-t border-accent/20">
          <div className="flex items-start space-x-3">
            <Icon 
              name="Info" 
              size={16} 
              className="text-accent mt-0.5 flex-shrink-0" 
            />
            <div className="text-sm text-accent/80">
              {selectedAction === 'activate' && (
                <p>سيتم تفعيل جميع الاتحادات الفرعية المحددة ({selectedItems?.length} عنصر)</p>
              )}
              {selectedAction === 'deactivate' && (
                <p>سيتم إلغاء تفعيل جميع الاتحادات الفرعية المحددة ({selectedItems?.length} عنصر)</p>
              )}
              {selectedAction === 'export' && (
                <p>سيتم تصدير بيانات الاتحادات الفرعية المحددة إلى ملف Excel ({selectedItems?.length} عنصر)</p>
              )}
              {selectedAction === 'delete' && (
                <p className="text-error">
                  <Icon name="AlertTriangle" size={14} className="inline mr-1" />
                  تحذير: سيتم حذف جميع الاتحادات الفرعية المحددة نهائياً ({selectedItems?.length} عنصر)
                </p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkActions;